import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../shared/api.service';
import { Globals } from '../shared/globals';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { TooltipModule } from 'ng2-tooltip-directive';
declare var Stripe; // : stripe.StripeStatic;

@Component({
  selector: 'app-join-form',
  templateUrl: './join-form.component.html',
  styleUrls: ['./join-form.component.css']
})
export class JoinFormComponent implements OnInit {

  user: any = {
    stage: 'Intro',
    prefix: '',
    firstName: '',
    lastName: '',
    email: '',
    rightsholderName: '',
    jobTitle: '',
    contactNumber: '',
    rightsholder: false,
    primaryContact: false,
    receiveMarketing: false,
    age: '',
    sex: '',
    bio: '',
    address1: '',
    address2: '',
    city: '',
    postcode: '',
    country: 'United Kingdom',
    mainPhone: '',
    bpiMember: false,
    merlinMember: false,
    a2imMember: false,
    mmfMember: false,
    muMember: false,
    mpaMember: false,
    mpgMember: false,
    facMember: false,
    howCollectPerformanceRevenue: '',
    pplMemberName: '',
    pplMemberNo: '',
    website: '',
    facebook: '',
    twitter: '',
    instagram: '',
    linkedIn: '',
    staff: [], //[{ firstName: String, lastName: String, email: String, phone: String }],
    billingName: '',
    billingAddress1: '',
    billingAddress2: '',
    billingCity: '',
    billingPostcode: '',
    billingCountry: 'United Kingdom',
    vatNo: '',
    discountCode: '',
    amount: ''
  };
  page = 'Intro';
  copyCompanyToBilling = false;
  submitDisabled = false;
  id;

  tooltipOptions = {
    width: 500,
    'max-width': 500
  }

  page0RequireFields = {
    rightsholder: false,
    termsAndConditions: false,
    independent: false,
    ukOrIeBased: false
  }

  page1RequireFields = {
    prefix: false,
    firstName: false,
    lastName: false,
    email: false,
    rightsholderName: false,
    jobTitle: false,
    contactNumber: false,
    primaryContact: false,
  }

  page2RequireFields = {
    rightsholderName: false,
    address1: false,
    city: false,
    postcode: false,
    country: false,
    mainPhone: false,
    howCollectPerformanceRevenue: false,
    pplMemberName: false,
    pplMemberNo: false
  }

  page4RequireFields = {
    billingName: false,
    billingAddress1: false,
    billingCity: false,
    billingPostcode: false,
    billingCountry: false
  }

  conrfirmEmailError = false;
  emailNotUniqueError = false;
  pplMemberNameError = false;
  pplMemberNoError = false;

  staffErrors = [];

  cardCharge = 145;
  discountType;
  discountPercentage = 0;
  discountAmount = 0;

  territories = ["Algeria", "Angola", "Benin", "Botswana", "Burkina Faso", "Burundi", "Cameroon", "Cape Verde", "Central African Republic", "Chad", "Comoros", "Congo, Republic of the", "Congo, The Democratic Republic Of The", "Cote d'Ivoire", "Djibouti", "Egypt", "Equatorial Guinea", "Eritrea", "Ethiopia", "Gabon", "Gambia, The", "Ghana", "Guinea", "Guinea-Bissau", "Kenya", "Lesotho", "Liberia", "Libya", "Madagascar", "Malawi", "Mali", "Mauritania", "Mauritius", "Mayotte", "Morocco", "Mozambique", "Namibia", "Niger", "Nigeria", "Reunion", "Rwanda", "Saint Helena", "Sao Tome and Principe", "Senegal", "Seychelles", "Sierra Leone", "Somalia", "South Africa", "South Sudan", "Sudan", "Swaziland", "Tanzania", "Togo", "Tunisia", "Uganda", "Western Sahara", "Zambia", "Zimbabwe", "Aruba", "Anguilla", "Antigua and Barbuda", "Argentina", "Bahamas, The", "Barbados", "Belize", "Bermuda", "Bolivia", "Brazil", "British Virgin Islands", "Canada", "Cayman Islands", "Chile", "Colombia", "Costa Rica", "Cuba", "Curacao", "Dominica", "Dominican Republic", "Ecuador", "El Salvador", "Falkland Islands (Islas Malvinas)", "French Guiana", "Greenland", "Grenada", "Guadeloupe", "Guatemala", "Guyana", "Haiti", "Honduras", "Jamaica", "Martinique", "Mexico", "Montserrat", "Netherlands Antilles", "Nicaragua", "Panama", "Paraguay", "Peru", "Puerto Rico", "Saint Barthelemy", "Saint Kitts and Nevis", "Saint Lucia", "Saint Martin", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Suriname", "Trinidad and Tobago", "Turks and Caicos Islands", "United States", "Uruguay", "Venezuela", "Virgin Islands", "Afghanistan", "Armenia", "Azerbaijan", "Bahrain", "Bangladesh", "Bhutan", "Brunei", "Cambodia", "China", "Georgia", "Hong Kong", "India", "Indonesia", "Iran", "Iraq", "Israel", "Japan", "Jordan", "Kazakhstan", "Korea, North", "Korea, South", "Kuwait", "Kyrgyzstan", "Laos", "Lebanon", "Macao", "Malaysia", "Maldives", "Mongolia", "Myanmar (Burma)", "Nepal", "Oman", "Pakistan", "Palestinian Territories", "Philippines", "Qatar", "Saudi Arabia", "Singapore", "Sri Lanka", "Syria", "Taiwan", "Tajikistan", "Thailand", "Timor-Leste", "Turkey", "Turkmenistan", "United Arab Emirates", "Uzbekistan", "Vietnam", "Yemen", "Albania", "Andorra", "Austria", "Belarus", "Belgium", "Bosnia and Herzegovina", "Bulgaria", "Croatia", "Cyprus", "Czech Republic", "Denmark", "Estonia", "Faroe Islands", "Finland", "France", "Germany", "Gibraltar", "Greece", "Guernsey", "Holy See (Vatican City)", "Hungary", "Iceland", "Ireland", "Isle Of Man", "Italy", "Jersey", "Latvia", "Liechtenstein", "Lithuania", "Luxembourg", "Macedonia", "Malta", "Moldova", "Monaco", "Montenegro", "Netherlands", "Norway", "Poland", "Portugal", "Romania", "Russia", "San Marino", "Serbia", "Slovakia", "Slovenia", "Spain", "Svalbard", "Sweden", "Switzerland", "Ukraine", "United Kingdom", "Aland Islands", "American Samoa", "Antarctica", "Australia", "Bouvet Island", "British Indian Ocean Territory", "Christmas Island", "Cocos (Keeling) Islands", "Cook Islands", "Fiji", "French Polynesia", "French Southern Territories", "Guam", "Heard and McDonald Islands", "Kiribati", "Marshall Islands", "Micronesia, Federated States of", "Nauru", "New Caledonia", "New Zealand", "Niue", "Norfolk Island", "Northern Mariana Islands", "Palau", "Papua New Guinea", "Pitcairn Islands", "Solomon Islands", "South Georgia and South Sandwich Island", "Tokelau", "Tonga", "Tuvalu", "US Minor Outlying Islands", "Vanuatu", "Wallis and Futuna", "Western Samoa"].sort();

  @ViewChild('cardElement') cardElement: ElementRef;
  stripe; // : stripe.Stripe;
  card;
  cardErrors;
  client_secret;
  discountError;
  discountSuccess;

  constructor(private route: ActivatedRoute, private router: Router, private http: ApiService, private globals: Globals, public ngxSmartModalService: NgxSmartModalService, public tooltipModule: TooltipModule) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.route.queryParams.subscribe(queryParams => {
        if (params['id']) {
          this.id = params['id'];
          this.http.get('/signups/' + this.id, {}).subscribe(data => {
            this.user = data;
            this.page = this.user.stage;
          });
        }
      });
    });
  }

  ngAfterViewInit() {
    this.stripe = Stripe(this.globals.stripeKey);
    var elements = this.stripe.elements();

    this.card = elements.create('card');

    this.card.mount(this.cardElement.nativeElement);

    this.card.addEventListener('change', ({ error }) => {
      this.cardErrors = error && error.message;
    });
  }

  addStaffMember() {
    this.user['staff'].push({});
  }

  deleteStaffMember(index) {
    this.user['staff'].splice(index, 1);
  }

  async submitForm(e) {
    let controller = this;
    if (controller.cardCharge != 0) {
      controller.submitDisabled = true;
      this.http.post('/payments/getClientSecret', { charge: this.cardCharge, email: this.user.email }, {})
        .subscribe((data) => {
          this.client_secret = data['client_secret'];
          this.globals.spinnerLoading = true;

          this.stripe.handleCardPayment(
            controller.client_secret, controller.card, {
            payment_method_data: {
              billing_details: {
                name: controller.user.rightsholderName,
                email: controller.user.email
              }
            }
          }
          ).then(function (result) {
            if (result.error) {
              // Inform the customer that there was an error.
              controller.cardErrors = result.error.message;
              controller.submitDisabled = false;
              controller.globals.spinnerLoading = false;
            } else {
              // Send the token to the server.
              controller.http.post('/payments', { token: result.paymentIntent, user: controller.user }, {})
                .subscribe((data) => {
                  if (data['error']) {
                    controller.cardErrors = data['error']
                    controller.submitDisabled = false;
                  } else {
                    //Payment successful
                    controller.user.stage = 'Complete';
                    controller.page = 'Complete';
                    window.scroll(0, 350);
                  }
                });
            }
          });
        });
    } else {
      this.globals.spinnerLoading = true;
      controller.http.post('/payments', { user: controller.user }, {})
        .subscribe((data) => {
          if (data['error']) {
            controller.cardErrors = data['error']
            controller.submitDisabled = false;
          } else {
            //Payment successful
            controller.user.stage = 'Complete';
            controller.page = 'Complete';
            window.scroll(0, 350);
          }
        });
    }
  }

  onNext(page) {
    this.recalculateBilling();
    let error = false;

    if (this.user.stage == 'Intro') {
      this.page0RequireFields = {
        rightsholder: false,
        termsAndConditions: false,
        independent: false,
        ukOrIeBased: false
      }

      for (var key in this.page0RequireFields) {
        if (!this.user[key]) {
          this.page0RequireFields[key] = true
          error = true;
        }
      }
    }

    if (this.user.stage == 'About You') {
      console.log('To Company');
      this.page1RequireFields = {
        prefix: false,
        firstName: false,
        lastName: false,
        email: false,
        rightsholderName: false,
        jobTitle: false,
        contactNumber: false,
        primaryContact: false,
      }

      this.conrfirmEmailError = false;

      for (var key in this.page1RequireFields) {
        if (!this.user[key]) {
          this.page1RequireFields[key] = true
          error = true;
        }
      }

      if (this.user.email != this.user.confirmEmail) {
        this.conrfirmEmailError = true
        error = true;
      }
    }

    if (this.user.stage == 'Company') {
      this.page2RequireFields = {
        rightsholderName: false,
        address1: false,
        city: false,
        postcode: false,
        country: false,
        mainPhone: false,
        howCollectPerformanceRevenue: false,
        pplMemberName: false,
        pplMemberNo: false
      }

      // if (this.user.howCollectPerformanceRevenue == 'Directly' || this.user.howCollectPerformanceRevenue == 'Directly & Agent') {
      //   console.log(this.user);
      //   if (!this.user.pplMemberName || this.user.pplMemberName == "") {
      //     this.page2RequireFields['pplMemberNameError'] = true;
      //   } else {
      //     delete this.page2RequireFields['pplMemberNameError'];
      //   }
      //   if (!this.user.pplMemberNo || this.user.pplMemberNo == "") {
      //     this.page2RequireFields['pplMemberNoError'] = true;
      //   } else {
      //     delete this.page2RequireFields['pplMemberNoError'];
      //   }
      // } else {
      //   delete this.page2RequireFields['pplMemberNameError'];
      //   delete this.page2RequireFields['pplMemberNoError'];
      // }

      for (var key in this.page2RequireFields) {
        if (!this.user[key] || this.user[key] == "") {
          this.page2RequireFields[key] = true
          error = true;
        }
      }

    }

    if (this.user.stage == 'Staff') {
      let controller = this;
      this.staffErrors = [];

      this.user.staff.map(function (staff) {
        let staffError = {
          firstName: false,
          lastName: false,
          email: false,
          jobTitle: false
        }

        if (!staff.firstName) {
          staffError.firstName = true;
          error = true;
        }

        if (!staff.lastName) {
          staffError.lastName = true;
          error = true;
        }

        if (!staff.email) {
          staffError.email = true;
          error = true;
        }

        if (!staff.jobTitle) {
          staffError.jobTitle = true;
          error = true;
        }

        controller.staffErrors.push(staffError);
      });

    }

    if (this.user.stage == 'Billing') {
      this.page4RequireFields = {
        billingName: false,
        billingAddress1: false,
        billingCity: false,
        billingPostcode: false,
        billingCountry: false
      }

      for (var key in this.page4RequireFields) {
        if (!this.user[key]) {
          this.page4RequireFields[key] = true
          error = true;
        }
      }

    }

    if (!error) {
      window.scroll(0, 350);
      if (this.page == 'About You') {
        this.emailNotUniqueError = false;
        this.http.post('/users/is-email-unique', { email: this.user.email }, {}).subscribe((data: any) => {
          if (data == true) {
            this.page = page;
            this.user.stage = page;

            if (this.id) {
              this.http.put('/signups/' + this.id, this.user, {}).subscribe(data => {
                this.user = data;
              });
            } else {
              this.http.post('/signups', this.user, {}).subscribe(data => {
                this.user = data;
                this.id = this.user['_id'];
              });
            }
          } else {
            this.emailNotUniqueError = true;
          }
        })
      } else {
        this.page = page;
        this.user.stage = page;

        if (this.id) {
          this.http.put('/signups/' + this.id, this.user, {}).subscribe(data => {
            this.user = data;
          });
        } else {
          this.http.post('/signups', this.user, {}).subscribe(data => {
            this.user = data;
            this.id = this.user['_id'];
          });
        }
      }
    } else {
      window.scroll(0, 350);
    }
  }

  recalculateBilling() {
    var obj = this;
    var euTerritories = ["Austria", "Belgium", "Bulgaria", "Croatia", "Cyprus", "Czechia", "Denmark", "Estonia", "Finland", "France", "Germany", "Greece", "Hungary", "Ireland", "Italy", "Latvia", "Lithuania", "Luxembourg", "Malta", "Netherlands", "Poland", "Portugal", "Romania", "Slovakia", "Slovenia", "Spain", "Sweden"];
    var discountMultiplier = 100;
    if (this.discountPercentage) { discountMultiplier -= this.discountPercentage; }
    discountMultiplier = discountMultiplier / 100;
    if (this.user.billingCountry && this.user.billingCountry == "United Kingdom") {
      this.cardCharge = (145 - this.discountAmount) * discountMultiplier * 1.2;
    } else {
      this.cardCharge = (145 - this.discountAmount) * discountMultiplier;
    }
    this.user['amount'] = this.cardCharge;

  }

  checkVatNo(callback) {
    if (this.user.vatNo && this.user.vatNo != "") {
      this.http.get('/vat', { vat: this.user.vatNo }).subscribe(data => {
        console.log(data);
        if (data && data['result']) {
          callback(true);
        } else {
          callback(false);
        }
      })
    } else {
      callback(false);
    }
  }

  applyDiscount() {
    this.discountError = '';
    this.discountSuccess = '';

    this.http.post('/discounts/apply', { code: this.user.discountCode }, {}).subscribe(data => {
      this.discountSuccess = data['message'];
      if (data['type'] == 'Percentage') {
        this.discountPercentage = data['amount'];
      } else if (data['type'] == 'Amount') {
        this.discountAmount = data['amount'];
      }
      this.recalculateBilling();
    }, err => {
      this.discountError = err.error;
    });
  }

  updateBillingInfo() {
    this.user['billingName'] = this.user['rightsholderName'];
    this.user['billingAddress1'] = this.user['address1'];
    this.user['billingAddress2'] = this.user['address2'];
    this.user['billingCity'] = this.user['city'];
    this.user['billingPostcode'] = this.user['postcode'];
    this.user['billingCountry'] = this.user['country'];
  }

}
